import React from 'react';
import {MessageSquare} from 'lucide-react';
import MiddleStageTeacherFeedbackViewer from './MiddleStageTeacherFeedbackViewer';
import {isMiddleGrade} from '../../utils/gradeUtils';

/**
 * Component for displaying teacher feedback
 * Enhanced to support detailed middle-stage feedback
 *
 * @param {Object} props
 * @param {Object} props.submission - Submission data including teacher feedback
 * @param {Object} props.selectedClass - The selected class data (for grade info)
 */
const TeacherFeedback = ({submission, selectedClass}) => {
    // Determine if this is a middle stage submission based on class grade
    const grade = selectedClass?.grade ? parseInt(selectedClass.grade, 10) : 1;
    const isMiddle = isMiddleGrade(grade);

    console.log("Is Middle:",isMiddle);
    console.log("Submission Data:",submission);

    // For middle stage, use the specialized feedback viewer
    if (isMiddle) {
        return (
            <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
                <div className="p-6 border-b border-gray-100 bg-gray-50">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#D67C2C]">
                            <MessageSquare className="w-5 h-5 text-white"/>
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900 font-[poppins]">Teacher Feedback</h2>
                            <p className="text-sm text-gray-600 mt-1">
                                Comprehensive assessment and guidance from your teacher
                            </p>
                        </div>
                    </div>
                </div>
                <div className="p-6">
                    <MiddleStageTeacherFeedbackViewer submission={submission}/>
                </div>
            </div>
        );
    }

    // For non-middle stage, use the original simple feedback display
    return (
        <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
            <div className="p-6 border-b border-gray-100 bg-gray-50">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#D67C2C]">
                        <MessageSquare className="w-5 h-5 text-white"/>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-900 font-[poppins]">Teacher Feedback</h2>
                </div>
            </div>
            <div className="p-6">
                {submission && submission.observational_notes ? (
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                        <p className="text-sm text-blue-900 font-medium leading-relaxed">
                            {submission.observational_notes}
                        </p>
                    </div>
                ) : (
                    <div className="text-center py-8">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <MessageSquare className="h-8 w-8 text-gray-400"/>
                        </div>
                        <p className="text-lg font-medium text-gray-500 mb-2">No feedback yet</p>
                        <p className="text-sm text-gray-400">
                            Your teacher will provide feedback once they review your submission
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeacherFeedback;